interface IResource {
  name: string;
  src: string;
}
export const StyleResources: IResource[] = [
  { name: 'bootstrap',src: 'bootstrap.min.css'},
  { name: 'font-awesome',src: 'font-awesome.min.css'},
  { name: 'animate',src: 'animate.css'},
  { name: 'owl-carousel',src: 'owl.carousel.min.css'},
  { name: 'normalize',src: 'normalize.css'},
  { name: 'style',src: 'xemart.css'},
  { name: 'responsive',src: 'responsive.css'},
  { name: 'custom-style',src: 'custom-style.css'},
  { name: 'custom-responsive',src: 'custom-responsive.css'},
  { name: 'countrySelect', src: 'countrySelect.min.css'},
  { name: 'dd', src: 'dd.css'}
];
export const ScriptResources: IResource[] = [
 { name: 'jquery',src: 'jquery-1.12.4.min.js'},
  { name: 'popper',src: 'popper.min.js'},
  { name: 'bootstrap',src: 'bootstrap.min.js'},
  { name: 'owl-carousel',src: 'owl.carousel.min.js'},
  { name: 'wow',src: 'wow.min.js'},
  { name: 'price',src: 'price-filter.js'},
  { name: 'meanmenu',src: 'jquery.meanmenu.min.js'},
  { name: 'countrySelect', src: 'countrySelect.min.js'},
  { name: 'dd', src: 'dd.min.js'}
];
